"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _font = require("../constants/font");
var _obj;
/* eslint-disable @typescript-eslint/naming-convention -- css selectors */ /*
 * NOTE
 * Theme update in a project using createTheme that updates a color and/or a font definition will not affect definition here.
 * If you are overriding color definition (for example dark mode or a holyday theme) then you need to handle `a` and `hr` separately.
 * If your element is wrapped in ScopedCssBaseline, that will bring back automation.
 */ var styleOverrides = (_obj = {
    // Body and Html
    html: {
        height: '100%',
        webkitTextSizeAdjust: '100%',
        webkitFontSmoothing: 'antialiased',
        mozOsxFontSmoothing: 'grayscale',
        fontSize: _constants.font.htmlFontSizeAdjust
    },
    body: {
        minHeight: '100%',
        margin: 0,
        overflow: 'auto',
        fontSize: '1.4rem'
    },
    a: {
        color: _constants.colors.text.primary,
        textDecoration: 'none'
    }
}, _define_property(_obj, "a:hover,a:focus", {
    color: _constants.colors.text.hover
}), // Mostly action elements (button, a, audio, video, etc...)
_define_property(_obj, "\n  html,\n  body,\n  button,\n  input,\n  optgroup,\n  select,\n  textarea", {
    fontFamily: _font.fontFamily
}), _define_property(_obj, "\n  article,\n  aside,\n  details,\n  figcaption,\n  figure,\n  footer,\n  header,\n  hgroup,\n  nav,\n  section,\n  summary,\n  hr", {
    display: 'block'
}), _define_property(_obj, "\n  audio,\n  canvas,\n  video", {
    display: 'inline-block'
}), _define_property(_obj, "audio:not([controls])", {
    display: 'none',
    height: 0
}), _define_property(_obj, "\n  iframe,\n  button", {
    border: 'none'
}), // Mostly text elements (h*, b, strong, hr, etc...)
_define_property(_obj, "h1", {
    fontSize: '2em',
    margin: '.67em 0'
}), _define_property(_obj, "\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6", {
    margin: 0,
    fontWeight: _font.fontWeightRegular
}), _define_property(_obj, "\n  b,\n  strong", {
    fontWeight: _font.fontWeightBold
}), _define_property(_obj, "blockquote", {
    margin: '1em 0 1em 40px'
}), _define_property(_obj, "hr", {
    height: 1,
    border: 0,
    borderTop: "1px solid ".concat(_constants.colors.oriGrey[300]),
    padding: 0
}), _define_property(_obj, "hr,\n  p,\n  pre", {
    margin: '1em 0'
}), _define_property(_obj, "\n  code,\n  pre", {
    fontSize: '1rem',
    fontFamily: 'monospace, serif'
}), _define_property(_obj, "pre", {
    whiteSpace: 'pre-wrap'
}), _define_property(_obj, "small", {
    fontSize: '80%'
}), _define_property(_obj, "\n  sub,\n  sup", {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline'
}), _define_property(_obj, "sup", {
    top: '-.5em'
}), _define_property(_obj, "sub", {
    bottom: '-.25em'
}), _define_property(_obj, "\n  ol,\n  ul", {
    margin: 0,
    padding: 0
}), _define_property(_obj, "\n  nav ol,\n  nav ul", {
    listStyle: 'none',
    listStyleImage: 'none'
}), // Mostly images, SVGs..
_define_property(_obj, "img", {
    border: 0,
    verticalAlign: 'middle',
    maxWidth: '100%',
    height: 'auto'
}), _define_property(_obj, 'svg:not(:root)', {
    overflow: 'hidden'
}), // Mostly form controls & elements
_define_property(_obj, 'label[for]', {
    cursor: 'pointer'
}), _define_property(_obj, "\n  button,\n  input,\n  select,\n  textarea", {
    fontSize: '1.6rem',
    margin: 0,
    verticalAlign: 'middle'
}), _define_property(_obj, 'button,input', {
    lineHeight: 'normal'
}), _define_property(_obj, "\n  button,\n  html input[type=button],\n  input[type=reset],\n  input[type=submit]", {
    webkitAppearance: 'button',
    cursor: 'pointer'
}), _define_property(_obj, "\n  button[disabled],\n  html input[disabled],\n  input[disabled]", {
    cursor: 'default'
}), _define_property(_obj, "\n  input[type=checkbox],\n  input[type=radio]", {
    webkitBoxSizing: 'border-box',
    boxSizing: 'border-box',
    padding: 0
}), _define_property(_obj, 'input[type=text]::-ms-clear', {
    display: 'none'
}), _define_property(_obj, "textarea", {
    overflow: 'auto',
    verticalAlign: 'top'
}), _define_property(_obj, "\n  button::-moz-focus-inner,\n  input::-moz-focus-inner", {
    border: 0,
    padding: 0
}), _define_property(_obj, 'input[type=search]', {
    boxSizing: 'content-box',
    webkitAppearance: 'textfield',
    webkitBoxSizing: 'content-box'
}), // Other
_define_property(_obj, "table", {
    borderCollapse: 'collapse',
    borderSpacing: 0
}), _define_property(_obj, "th", {
    fontWeight: _font.fontWeightRegular
}), _define_property(_obj, "\n  body,\n  button,\n  figure", {
    margin: 0
}), // Scrollbar
_define_property(_obj, '@media (hover: hover) and (pointer: fine)', {
    '&, & *': {
        msOverflowStyle: '-ms-autohiding-scrollbar',
        scrollbarWidth: 'thin',
        scrollbarColor: "".concat(_constants.colors.oriGrey[300], " transparent")
    },
    '::-webkit-scrollbar': {
        width: '15px',
        height: '15px'
    },
    '::-webkit-scrollbar-track': {
        background: 'transparent'
    },
    '::-webkit-scrollbar-thumb': {
        background: _constants.colors.oriGrey[300],
        borderRadius: '13px',
        border: '5px solid transparent',
        backgroundClip: 'content-box'
    }
}), _obj);
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiCssBaseline.js.map
